'use es6';

import { useMemo } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import * as CustomPropTypes from '../../../constants/PropTypes';
import emptyFunction from 'react-utils/emptyFunction';
import UICardGrid from 'UIComponents/card/UICardGrid';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import ThinListing from 'ecosystem-marketplace-core/records/ThinListing';
import * as RequestState from 'marketplace-ui-common/requestStates/RequestState';
import { isFulfilled } from 'marketplace-ui-common/requestStates/RequestStateUtils';
import ResultCard from './ResultCard';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import { jsx as _jsx } from "react/jsx-runtime";
const ResultsGrid = ({
  className,
  isAdminPreview,
  onResultClick,
  requestState,
  resultProps,
  results
}) => {
  const responsiveProps = useResponsiveProps({
    columns: {
      xs: 1,
      lg: 2,
      xl: 3
    }
  });
  const renderedResults = useMemo(() => {
    return results.toArray().map((result, index) => {
      return /*#__PURE__*/_jsx(ResultCard, Object.assign({}, resultProps, {
        isAdminPreview: isAdminPreview,
        onClick: () => {
          onResultClick(result, index);
        },
        result: result
      }), result.id);
    });
  }, [isAdminPreview, onResultClick, resultProps, results]);
  if (!isFulfilled(requestState)) {
    return /*#__PURE__*/_jsx(UILoadingSpinner, {
      "data-selenium-id": "results-loading-spinner",
      grow: true,
      minHeight: 150,
      layout: "centered"
    });
  }
  return /*#__PURE__*/_jsx(UICardGrid, Object.assign({}, responsiveProps, {
    className: className,
    gutterSize: 16,
    children: renderedResults
  }));
};
ResultsGrid.propTypes = {
  className: PropTypes.string,
  isAdminPreview: PropTypes.bool,
  onResultClick: PropTypes.func,
  requestState: CustomPropTypes.requestState,
  resultProps: PropTypes.object,
  results: ImmutablePropTypes.iterableOf(PropTypes.instanceOf(ThinListing)).isRequired
};
ResultsGrid.defaultProps = {
  onResultClick: emptyFunction,
  resultProps: {},
  requestState: RequestState.SUCCEEDED
};
export default ResultsGrid;